import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { Box, Spinner } from '@chakra-ui/core';
import { foldersAPI } from '../common/api/folders';
import { normalizeFolderNumber } from '../common/helpers/folderNumber';
import routes, { getFolderPath } from '../common/routes';
import { PageError, PageError404, PageError500 } from '../errors/components';
import { checkPermissions } from '../roleBasedAccess/Can';

const FolderByNumber = ({
  match: {
    params: { number: rawNumber, section, step, itemIndex },
  },
  user,
}) => {
  const [result, setResult] = useState({});
  const number = normalizeFolderNumber(rawNumber);
  const requestedBloc = Object.keys(routes.folders).find(key =>
    [routes.folders[key].index, encodeURI(routes.folders[key].index)].includes(`/${section}`),
  );
  const validPath =
    /^[0-9]+$/.test(number) &&
    (!section || (requestedBloc && /^[1-9][0-9]*$/.test(step))) &&
    (itemIndex === undefined ||
      (['bloc_f', 'bloc_g'].includes(requestedBloc) && /^[1-9][0-9]*$/.test(itemIndex)));

  useEffect(() => {
    let active = true;
    if (validPath) {
      foldersAPI.getFolderByNumber(number).then(
        ({ folder }) => active && setResult({ number, folder }),
        error => active && setResult({ number, error: error.response?.status || 500 }),
      );
    }
    return () => {
      active = false;
    };
  }, [number, validPath]);

  if (!validPath || (result.number === number && result.error === 404)) {
    return <PageError404 />;
  }
  if (result.number === number && result.error) return <PageError500 />;
  if (result.number !== number || !result.folder) {
    return (
      <Box p={8}>
        <Spinner label="Recherche du dossier…" />
      </Box>
    );
  }

  const { folder } = result;
  const currentBloc = routes.folders[folder.currentBloc] ? folder.currentBloc : 'bloc_0';
  const candidateBlocs = requestedBloc
    ? [requestedBloc]
    : [
        currentBloc,
        'bloc_0',
        'bloc_fio',
        'bloc_a',
        'bloc_c',
        'bloc_d',
        'bloc_e',
        'bloc_f',
        'bloc_g',
        'bloc_h',
        'bloc_i',
      ];
  const bloc = candidateBlocs.find(
    key =>
      checkPermissions(user?.role, 'folder:read', { user }) ||
      checkPermissions(user?.role, `folder:${key}:read`, { user }),
  );

  if (!bloc) return <PageError text="Accès au dossier non autorisé" />;
  const destinationStep = itemIndex ? `${step}/${itemIndex}` : step;
  return <Redirect to={getFolderPath(bloc, folder.id, destinationStep)} />;
};

export default connect(({ authentication: { user } }) => ({ user }))(FolderByNumber);
